module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-app"
  }, [_c('section', {
    staticClass: "room"
  }, [_c('card-line', {
    staticClass: "test-line top-line",
    attrs: {
      "slack": "0.1"
    }
  }, _vm._l((_vm.cards), function(card, i) {
    return _c('folded-card', {
      key: i,
      class: {
        'test-card': true,
      },
      attrs: {
        "orientation": card.orientation,
        "is-closed": "true"
      }
    }, [_c('img', {
      staticClass: "cover-image",
      attrs: {
        "slot": "cover-front",
        "src": 'assets/cards/' + card.name + '/cover.png'
      },
      on: {
        "click": function($event) {
          _vm.setCarousel(_vm.cards, i)
        }
      },
      slot: "cover-front"
    })])
  })), _vm._v(" "), _c('card-line', {
    staticClass: "test-line bottom-line",
    attrs: {
      "slack": "0.15",
      "selected-card": "selectedCard - cards.length"
    }
  }, _vm._l((_vm.photos), function(photo, i) {
    return _c('photo-card', {
      key: i,
      class: {
        'test-card': true,
        'card--horizontal': photo.orientation == 'horizontal',
          'card--vertical': photo.orientation == 'vertical'
      }
    }, [_c('img', {
      staticClass: "cover-image",
      attrs: {
        "slot": "card-front",
        "src": 'assets/cards/photos/' + photo.name + '.jpg'
      },
      on: {
        "click": function($event) {
          _vm.setCarousel(_vm.photos, i)
        }
      },
      slot: "card-front"
    })])
  })), _vm._v(" "), _c('footer', {
    staticClass: "floor"
  }, [_c('canvas', {
    ref: "floorCanvas",
    staticClass: "floor-canvas"
  })]), _vm._v(" "), _c('img', {
    staticClass: "couch",
    attrs: {
      "src": require("../assets/couch_5.png")
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "carousel-fade"
    }
  }, [(typeof _vm.activeIndex == 'number') ? _c('carousel', {
    attrs: {
      "type": _vm.activeType,
      "cards": _vm.activeCarousel,
      "cursor": _vm.activeIndex
    },
    on: {
      "close": function($event) {
        _vm.closeCarousel()
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5599d3a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 35
// module chunks = 0